import {Component, OnInit} from '@angular/core';

//services
import { InformationService} from '../services/information.service';

@Component({
    selector: 'app-technical',
    templateUrl: './technical.component.html',
    styleUrls: ['./technical.component.css'],
    providers: [ InformationService ]
})
export class TechnicalComponent implements OnInit{
    welcome : string;
    subtitle : string;
    loading: string;
    searchTech : string;
    technical_skills: any[] = [];

    constructor(private informationService: InformationService){
        this.welcome = "Technical Skills";
        this.subtitle = "What I have used or learn during university or at work!";
        this.loading = "Loading...";
    }

    ngOnInit() {
        this.informationService.getTechnical().subscribe(response => {this.technical_skills = response.json()});
    }
};